import ModalCanvas2 from '~/components/Modal3D2';
function Following() {
    return (
        <div
            style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
            <div style={{ width: '700px', height: '600px' }}>
                <ModalCanvas2 />
            </div>
        </div>
    );
}

export default Following;
